import React from "react";
import { Flex, Button, Text } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

import { PageHeader } from "../../page-header/pageHeader";

import { AudioTestEndedIssueProps } from "./AudioTestEndedIssue.types";
import { useAudioTestEndedIssueStyles } from "./AudioTestEndedIssue.styles";

export const AudioTestEndedIssue: React.FC<AudioTestEndedIssueProps> = ({
  completeTest,
  runTestAgain,
}) => {
  const audioTestEndedIssueStyles = useAudioTestEndedIssueStyles();
  const { t } = useTranslation();

  return (
    <Flex
      vAlign="stretch"
      hAlign="center"
      gap="gap.large"
      column
      styles={audioTestEndedIssueStyles.container}
    >
      <Flex vAlign="center">
        <PageHeader
          headerStyles={audioTestEndedIssueStyles.finishPromptHeader}
          headerContent={t("MIC_OR_SPEAKER_ERROR")}
          descriptionStyles={audioTestEndedIssueStyles.description}
          descriptionContent={t("TRY_FIXING_ERROR")}
        />
      </Flex>
      <Flex.Item push>
        <Flex
          column
          hAlign="center"
          vAlign="end"
          gap="gap.medium"
          styles={audioTestEndedIssueStyles.buttonGroup}
        >
          <Button
            className="focus-button"
            tabIndex={0}
            onClick={runTestAgain}
            fluid
            styles={audioTestEndedIssueStyles.finishTestButton}
            content={
              <Text
                content={<>{t("RUN_TEST_AGAIN")}</>}
                size="large"
                weight="semibold"
                align="center"
              />
            }
            data-testid="runTestAgainAfterIssue"
          />

          <Button
            className="focus-button"
            tabIndex={1}
            onClick={completeTest}
            fluid
            styles={audioTestEndedIssueStyles.runTestAgain}
            content={
              <Text
                content={<>{t("DONE")}</>}
                size="large"
                weight="semibold"
                align="center"
              />
            }
            data-testid="completeTestWithIssue"
          />
        </Flex>
      </Flex.Item>
    </Flex>
  );
};
